<link rel="stylesheet" href="../../core/typography.scss">
<template>

  <ShareProgramDialog ref="dialog"></ShareProgramDialog>

  <div data-page="assessments">
    <div class="main">

      <div class="callout-block">

        <div class="callout-block-heading">
          <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
            <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
            <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
            <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
            <path fill="#0061A6" d="M36,19H21c-1.1,0-2-0.9-2-2s0.9-2,2-2h15c1.1,0,2,0.9,2,2S37.1,19,36,19z"/>
            <path fill="#0061A6" d="M36,27H21c-1.1,0-2-0.9-2-2s0.9-2,2-2h15c1.1,0,2,0.9,2,2S37.1,27,36,27z"/>
            <path fill="#0061A6" d="M36,35H21c-1.1,0-2-0.9-2-2s0.9-2,2-2h15c1.1,0,2,0.9,2,2S37.1,35,36,35z"/>
            <circle fill="#0061A6" cx="14.5" cy="17" r="2.5"/>
            <circle fill="#0061A6" cx="14.5" cy="25" r="2.5"/>
            <circle fill="#0061A6" cx="14.5" cy="33" r="2.5"/>
          </svg>
          <div class="callout-block-heading-copy">
            <div class="callout-block-heading-copy-eyebrow">{{ $t('overview') }}</div>
            <div class="callout-block-heading-copy-title">{{ $t('programs-assessments') }}</div>
          </div>
        </div>

        <div class="callout-block-progress-section">
          <div class="callout-block-progress-section-eyebrow">{{ $t('progress') }}</div>
          <div class="callout-block-progress-section-row" v-for="submission in submissions.list">
            <div class="row-content">
              <div class="callout-block-progress-section-meta">
                <span class="callout-block-progress-section-name">
                  <a :href="`/${$i18n.locale}/overview?id=${submission.id}`">
                    {{ submission.name }}
                  </a>
                </span>
                <span class="callout-block-progress-section-percent">{{ submission.percentComplete }}%&nbsp;{{ $t('percent-complete') }}</span>
              </div>

              <div class="callout-block-progress-bar-track" :style="`--progress: ${submission.percentComplete}`">
                <div class="callout-block-progress-bar-bar">
                  <div class="callout-block-progress-bar-gradient"></div>
                </div>
              </div>


            </div>

            <MenuComponent>
              <MenuListItemComponent @click="dialog.show(submission)">
                <template v-slot:icon>
                  <Icon icon="group"/>
                </template>
                <template v-slot:default>
                  {{ $t('collaborate') }}
                </template>
              </MenuListItemComponent>
              <MenuListItemComponent @click="onDelete(submission)">
                <template v-slot:icon>
                  <Icon icon="delete"/>
                </template>
                <template v-slot:default>
                  {{ $t('delete') }}
                </template>
              </MenuListItemComponent>
            </MenuComponent>


          </div>
        </div>

        <div class="callout-block-actions callout-block-actions-no-label">
          <div class="callout-block-actions-label"></div>
          <div class="callout-block-actions-buttons">
            <router-link class="add-program button" :to="`/${$i18n.locale}/add-program`">
              <button type="button" class="rect">{{ $t('add-program') }}</button>
            </router-link>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
import Manager from '../../core/Manager';
import { ref, reactive, onMounted } from 'vue';
import RestService from "restService";
import ShareProgramDialog from './components/ShareProgramDialog.vue';

declare const API_URL: any;

const submissions = reactive(Manager.getInstance().submissions);

const user = Manager.getInstance().user;

const dialog = ref();

onMounted(() => {
  document.body.classList.remove('loading');
})

const onDelete = async (submission) => {
  if(!confirm(`${Manager.getInstance().i18n.global.t('delete-confirmation-sentence')} ${submission.name}?`)) {
    return;
  }
  await submissions.delete(submission.id);
  window.location.reload();
}

const downloadCsv = async () => {
  const downloadUrl = `${API_URL}/admin/submissions/csv`;
  const response = await RestService.get(downloadUrl);
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'submissions.csv');
  link.click();
}

</script>

<style lang="scss">
.g-dialog-content {
  max-width: 400px;
  padding: 20px;
  .actions {
    text-align: right;
    margin-top: 20px;
    a {
      margin-right: 20px;
    }
  }
}
.submission-shared {
  margin-top: 10px;
  .callout-block-progress-section-eyebrow {
    text-transform: none;
  }
  .shared-with-user {
    margin-top: 10px;
    font-size: 12px;
  }
}
</style>
